import React from 'react';
import { SearchableProfileList } from '@periscopes/general/profiles';
export const FieldProfilesTab = ({ index, sonarObjectId }) => {
    const targetUri = `v2/salesforce/SfFields/${sonarObjectId}/profiles`;
    return React.createElement(SearchableProfileList, { parentIndex: index, showTitle: true, uri: targetUri });
};
